<template>
    <slot name="picture"></slot>
    <div class="media_overlay" :class="getHoverColour()" @click="openOverlay">
        <span v-if="!isAVideoTile" @click="openOverlay">View</span>
    </div>
    
    <div class="media_play-button" :class="getMediaPlayButtonColour()" v-if="isAVideoTile" @click="openOverlay"></div>
    
    <div class="modal-teleport" v-if="show && isActive">
        <Teleport to="#modal_dialog">
            <div class="mec-modal-dialog-video" v-if="isAVideoTile">
                <slot name="modal-video"></slot>
            </div>
            <slot name="modal-image" v-if="!isAVideoTile"></slot>
        </Teleport>
      </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { storeToRefs } from 'pinia';
import useModalStore from '../store/useModalStore.js';

const store = useModalStore();
const { isActive } = storeToRefs(store);

let isAVideoTile = ref(false);
const show = ref(false);

const props = defineProps([
    'background',
    'videoLink',
]);

// check that the videoLink prop is not empty, assumed validation is handled in the PHP
onMounted(() => {
    if (props.videoLink !== '') {
        isAVideoTile.value = true;
    }
});

const openOverlay = () => {
    show.value = store.open();
}

const getHoverColour = () => {
    const background = props.background;

    if (background === 'white' || background === 'lightblue' || background === 'lightgrey'){
        return 'media_overlay--white';
    }

    return 'media_overlay--' + props.background;
}

const getMediaPlayButtonColour = () => {
    const background = props.background;
    if( background === 'lightpink' || background === 'lightpurple' || background === 'lightyellow' || background === 'darkpurple'){
        return 'media_play-button--' + background;
    }

    return 'media_play-button--blue';
}

watch(isActive, async(newState, oldState) => {
    if (!newState) {
        show.value = false;
    }
});
</script>